// extracted by mini-css-extract-plugin
module.exports = {"image":"PopularItemImage__image___3Lrw2","star":"PopularItemImage__star___1oHsy"};